export const slackDaysFormatter = (activity, gantt) => {
    const slack = activity.totalSlack;
    if (slack === undefined || slack === null || slack === '') {
      return { enFormatSlack: '', otherFormatSlack: '' };
    }
    const parseSlack = parseFloat(slack).toFixed(2);
    const enFormatSlack = parseSlack;
    const otherFormatSlack = parseSlack.replace('.', ',');

    return { enFormatSlack, otherFormatSlack };
};